import ReactGa from 'react-ga';

export class GoogleAnalytics {
    static initialise(googleAnalyticsTrackingId: string): void {
        ReactGa.initialize(googleAnalyticsTrackingId);
    }

    static setPageView(pageName: string): void {
        ReactGa.ga('set', 'location', pageName);
        ReactGa.pageview(pageName);
    }

    static trackEventsGoogleAnalytics(
        category: string,
        action: string,
        label: string
    ): void {
        ReactGa.event({
            category: category,
            action: action,
            label: label
        });
    }
}
